import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-76d6d1a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "blacklist-cntr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    "destroy-on-close": "",
    modelValue: _ctx.modalVisiable,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalVisiable) = $event)),
    "before-close": _ctx.closeModal,
    width: "470px"
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('groupClient.blacklistBlockedCannotJoinTitle')), 1)
    ]),
    default: _withCtx(() => [
      (_ctx.list.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blackList, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "item cm-ui-mb10",
                key: item.device_id
              }, [
                _createElementVNode("div", null, _toDisplayString(item.computer_name || _ctx.$t('groupClient.blacklistUnnamedTerminal')), 1),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "text",
                  onClick: ($event: any) => (_ctx.cancelBlackList(item.device_id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('groupClient.blacklistRestoreAction')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: _ctx.$t('groupClient.noData')
          }, null, 8, ["description"]))
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}